module.exports = __webpack_public_path__ + "img/peinture-etrier-red.54df43ed.jpg";